import { css, html, LitElement } from "lit";

import "../components/navbar";
import "../components/mapselector";

import { setTitle, trackPage } from "../common/client";
import { websiteStyles } from "../styles/website";

export class MapSelectPage extends LitElement {
  static styles = [
    websiteStyles,
    css`
      :host {
        display: block;
        width: 100vw;
        height: 100vh;
        background: #FFF;
        color: #000;
        padding-top: 70px;
      }          
    `,
  ];

  connectedCallback() {
    super.connectedCallback();

    trackPage();
    setTitle("Map Select");
  }

  render() {
    return html`
      <navbar-component></navbar-component>
      <map-selector-component></map-selector-component>
    `;
  }
}

customElements.define("map-select-page", MapSelectPage);
